export default __webpack_public_path__ + "static/media/Q09_願你每個工作日裡，都能輕快忙裡偷閒.0b766048.mp4";